module.exports = __webpack_public_path__ + "static/Slider5-c97248d562d71e6802f4235ad49a4e62.jpg";